const PROBABILITIES = {
  1: 'Altamente improvável',
  2: 'Improvável',
  3: 'Possível',
  4: 'Provável',
  5: 'Muito provável',
}

const CONSEQUENCES = {
  1: 'Insignificante',
  2: 'Tolerável',
  3: 'Moderada',
  4: 'Grave',
  5: 'Severa',
}

export { PROBABILITIES, CONSEQUENCES }
